<template>
  <div class="field-button">
    <button type="button" :class="{ 'btn-primary': data.Text !== 'Cancel' }" @click="onButtonClick(data)">
      <Localize :text="data.Text" />
    </button>
  </div>
</template>

<script>
import PreApproveMe from '@/services/PreApproveMe.js'
import Localize from '@/components/Localize.vue'

export default {
  name: 'FieldButton',
  components: {
    Localize
  },
  props: {
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String
  },
  data: () => {
    return {
      PreApproveMe
    }
  },
  methods: {
    alert: function(msg, type) {
      type = typeof type !== 'undefined' ? type : 'error'
      this.$store.commit('openToast', {
        text: msg,
        type
      })
    },
    isFormValid: function () {
      let isValid = true

      var errors = []
      var sections = this.$store.getters.getSectionList
      for (var i = 0; i < sections.length; i++)
        errors = errors.concat(this.$store.getters.sectionValidErrors(sections[i].Id, true))

      if (errors.length === 0)
        return true

      for (var i = 0; i < errors.length; i++)
        this.alert(errors[i])

      return false
    },
    completePage: function () {
      var errors = this.$store.getters.pageValidErrors(this.sectionid, this.pageid, this.$store.state.borrowerid)

      if (errors.length === 0)
        this.$store.commit('setPageComplete', this.pageid)
      else {
        for (var i = 0; i < errors.length; i++)
          this.alert(errors[i])
        return false
      }

      if (this.$store.getters.isSectionValid(this.sectionid))
        this.$store.commit('setSectionComplete', this.sectionid)

      return true
    },
    onButtonClick: function(field) {
      if (field.LinkType == 1) {
        // Internal link
        // Check current page fields
        this.$root.$emit('form:validate')
        if (field.Action == 2) {
          if (!this.completePage())
            return
        }

        if (field.Target) {
          this.$store.dispatch('navGo', field.Target)
          this.$root.$emit('update:sectionid')
          this.$root.$emit('update:pageid')
        } else this.alert('Something went wrong. Please try again later.')
      } else if (field.LinkType == 2) {
        // External link
        window.open(field.Target, '_blank')
      } else if (field.LinkType == 3) {
        // Submit form
        // Check all required fields
        this.$root.$emit('form:validate')

        if (!this.completePage())
          return

        var vm = this

        //if (this.$store.getters.isFormValid) {
        if (this.isFormValid()) {
          vm.$store.commit('setLoading', true)
          this.$store.commit('setSectionComplete', this.data)
          PreApproveMe.submitForm(
            this.$store.getters.getCompany.CompanyID,
            (this.$store.getters.getOfficer || {}).UserID || null,
            this.$store.state.form.data.LinkData,
            this.$store.state.saveData
          )
          .then(result => {
            if (!result || !result.Success || !result.Result) {
              vm.$store.commit('setLoading', false)
              vm.alert((result || {}).Message)
              return
            }

            vm.$store.commit('setSubmitResult', result)

            if (result.Result.Link) {
              window.location = result.Result.Link
            }
            else {
              vm.$store.commit('setLoading', false)
              vm.$store.commit('setSubmitResult', result.Result)
              vm.$store.dispatch('go', 'outro')
            }
          })
        } 
      } else {
        this.alert('Something went wrong. Please try again later.')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.field-button {
}
</style>
